import React, { useEffect } from 'react';
import {
	AppBar,
	Collapse,
	Divider,
	Drawer,
	IconButton,
	List,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Toolbar,
	Typography,
	MenuItem,
	Box,
	useMediaQuery,
	useTheme,
	Menu,
	Avatar,
	ListItemAvatar,
	Chip,
} from '@mui/material';

import itauPY from '../../../assets/country-flags/itauPY_flag.svg';
import bancard from '../../../assets/payment-processors/bancard.svg';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HomeIcon from '@mui/icons-material/Home';
import ListIcon from '@mui/icons-material/List';
import GroupsIcon from '@mui/icons-material/Groups';
import HubIcon from '@mui/icons-material/Hub';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddCardIcon from '@mui/icons-material/AddCard';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import HotelIcon from '@mui/icons-material/Hotel';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import SettingsIcon from '@mui/icons-material/Settings';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CashIcon, TransferIcon } from '../customIcons';
import MevueloLogo from '../../../assets/mevuelo-blanco.svg';
import { ReactComponent as StatsIcon } from '../../../assets/stats-line-chart-svgrepo-com.svg';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ImportExportIcon from '@mui/icons-material/ImportExport';

import makeStyles from '@mui/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SvgIcon from '@mui/material/SvgIcon';
import { Link as RouterLink } from 'react-router-dom';

// @ts-ignore
import backgroundSound from '../../../assets/felo.mp3';

import { actions } from 'features/auth/slice';
import { RootState } from 'store';
import routes from 'constants/routes';
import { CookieService, SessionService } from 'features/auth/services/CookieService';
import {
	ContentPaste,
	CurrencyExchange,
	ExpandLess,
	ExpandMore,
	HomeWork,
	PlaylistRemove,
	PriceChange,
} from '@mui/icons-material';
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import PublicIcon from '@mui/icons-material/Public';
import InventoryIcon from '@mui/icons-material/Inventory';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BarChartIcon from '@mui/icons-material/BarChart';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { CountryCodeEnum, OrderTypeEnum, orderTypes } from '../types';
import {
	getCountriesWithAgencyConfigForUser,
	isAdminOrSuperAdmin,
	isOperatorOrHigher,
	isSuperAdmin,
} from '../../auth/helpers';
import { countriesWithAgencyConfig } from 'features/auth/constants';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import StorefrontIcon from '@mui/icons-material/Storefront';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import PaymentsIcon from '@mui/icons-material/Payments';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import UploadFileIcon from '@mui/icons-material/UploadFile';
const useStyles = makeStyles((theme) => ({
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
		fontWeight: 'bold',
		fontSize: '1.5rem',
	},
	list: {
		width: 250,
		'&::-webkit-scrollbar': {
			width: '8px',
		},
		'&::-webkit-scrollbar-track': {
			backgroundColor: '#f1f1f1',
			borderRadius: '4px',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#c1c1c1',
			borderRadius: '4px',
			'&:hover': {
				backgroundColor: '#a8a8a8',
			},
		},
		overflowY: 'auto',
		maxHeight: 'calc(100vh - 64px)', // Altura máxima para permitir scroll
	},
	toolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: theme.spacing(0, 2),
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(0, 1),
		},
	},
	leftSection: {
		display: 'flex',
		alignItems: 'center',
		flex: 1,
	},
	centerSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flex: 1,
		[theme.breakpoints.down('md')]: {
			display: 'none',
		},
	},
	rightSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		flex: 1,
		gap: theme.spacing(1),
	},
	logo: {
		height: '40px',
		[theme.breakpoints.down('sm')]: {
			height: '32px',
		},
	},
	countrySelector: {
		minWidth: 120,
		marginLeft: theme.spacing(2),
		[theme.breakpoints.down('sm')]: {
			minWidth: 100,
			marginLeft: theme.spacing(1),
		},
	},
	countryChip: {
		backgroundColor: 'rgba(255, 255, 255, 0.9)',
		color: '#1976d2',
		fontWeight: 'bold',
		'& .MuiChip-avatar': {
			width: 24,
			height: 24,
		},
		'&:hover': {
			backgroundColor: 'rgba(255, 255, 255, 1)',
		},
	},
	flagIcon: {
		width: '24px',
		height: '18px',
		objectFit: 'cover',
		borderRadius: '2px',
	},
	userMenuButton: {
		color: 'white',
		padding: theme.spacing(0.5),
	},
}));

interface Props {
	children: JSX.Element;
}

const audio = new Audio(backgroundSound);

export const Layout = (props: Props): JSX.Element => {
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();
	const [drawerOpen, setDrawerOpen] = React.useState(false);
	const [quotationsOpen, setQuotationsOpen] = React.useState(false);
	const [salesOrderOpen, setSalesOrderOpen] = React.useState(false);
	const [explorerOpen, setExplorerOpen] = React.useState(false);
	const [productOpen, setProductOpen] = React.useState(false);
	const [productAnalyticsOpen, setProductAnalyticsOpen] = React.useState(false);
	const [paymentOpen, setPaymentOpen] = React.useState(false);
	const [transactionsListOpen, setTransactionsListOpen] = React.useState(false);
	const [quotationOptionsOpen, setQuotationOptionsOpen] = React.useState(false);
	const [operationsReportOpen, setOperationsReportOpen] = React.useState(false);
	const [statsOpen, setStatsOpen] = React.useState(false);
	const [rulesOpen, setRulesOpen] = React.useState(false);

	const [userMenuAnchor, setUserMenuAnchor] = React.useState<null | HTMLElement>(null);
	const [countryMenuAnchor, setCountryMenuAnchor] = React.useState<null | HTMLElement>(null);
	const { auth } = useSelector((state: RootState) => state);
	const handleMenuLink = (value: string) => () => history.push(value);
	const handleOrdersClick = (id: number) => history.push(routes.payment.order.replace(':id', `${id}`));
	const handleWireTransferCheckClick = () => history.push(routes.payment.wireTransferCheck);
	const handleOrderViajeNaranja = () => history.push(routes.payment.orderNaranja);
	const handleListViajeNaranjaBancardTransactionList = () =>
		history.push(routes.transactions.viajeNaranjaBancardTransactionList);
	const handleListViajeNaranjaPointTransactionList = () =>
		history.push(routes.transactions.viajeNaranjaItauPointTransactionList);
	const handleTransactionsClick = (orderTypeId: number) =>
		history.push(routes.transactions.gatewayTransactionList.replace(':orderTypeId', `${orderTypeId}`));
	const handleCountryChange = (selectedCountry: CountryCodeEnum) => {
		dispatch(actions.setCountry(selectedCountry));
		setCountryMenuAnchor(null);
	};

	const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setUserMenuAnchor(event.currentTarget);
	};

	const handleUserMenuClose = () => {
		setUserMenuAnchor(null);
	};

	const handleCountryMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setCountryMenuAnchor(event.currentTarget);
	};

	const handleCountryMenuClose = () => {
		setCountryMenuAnchor(null);
	};
	const [cardToAirlineOpen, setCardToAirlineOpen] = React.useState(false);
	const handleCardToAirlineCollapseClick = () => {
		setCardToAirlineOpen(!cardToAirlineOpen);
	};
	const countriesConfigToRender = getCountriesWithAgencyConfigForUser(auth.user?.agencies.map((x) => x.agencyId) || []);
	const currentCountryConfig = countriesConfigToRender.find((c) => c.id === auth.country);
	const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
		if (
			event.type === 'keydown' &&
			((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
		) {
			return;
		}
		setDrawerOpen((prevState) => !prevState);
	};
	const handleLogout = () => {
		CookieService.clearToken();
		CookieService.clearAgencies();
		SessionService.clearApiKey();
		location.reload();
	};
	useEffect(() => {
		if (auth.user?.email === 'fbuonomo@mevuelo.com') {
			audio.play();
		}
	}, []);

	useEffect(() => {
		const apiKey = SessionService.getApiKey();
		if (!apiKey) {
			const stringAgencies = CookieService.getAgencies();
			const agenciesIds = stringAgencies ? JSON.parse(stringAgencies) : [];

			const defaultAgency = countriesWithAgencyConfig.find((c) => c.agencyId === agenciesIds[0]?.agencyId);
			if (!defaultAgency) {
				handleLogout();
			} else {
				defaultAgency && SessionService.setApiKey(defaultAgency?.apiKey);
				const selectedCountry = defaultAgency?.id;
				selectedCountry && dispatch(actions.setCountry(selectedCountry));
			}
		}
	}, []);
	const handleQuotationsClick = () => setQuotationsOpen(!quotationsOpen);
	const handleSalesOrderClick = () => setSalesOrderOpen(!salesOrderOpen);
	const handleOperationsReportClick = () => setOperationsReportOpen(!operationsReportOpen);
	const handleExplorerClick = () => setExplorerOpen(!explorerOpen);
	const handleProductClick = () => setProductOpen(!productOpen);
	const handleProductAnalyticsClick = () => setProductAnalyticsOpen(!productAnalyticsOpen);
	const handlePaymentClick = () => setPaymentOpen(!paymentOpen);
	const handleStatsClick = () => setStatsOpen(!statsOpen);
	const handleTransactionsListClick = () => setTransactionsListOpen(!transactionsListOpen);
	const handleQuotationOptionsClick = () => setQuotationOptionsOpen(!quotationOptionsOpen);
	const handleRulesClick = () => setRulesOpen(!rulesOpen);

	const orderTypesAllowed = orderTypes.filter((x) => x.countriesAllow.indexOf(auth.country) > -1);
	const maybeOrderSimple = orderTypesAllowed.find((x) => x.id === OrderTypeEnum.SIMPLE);

	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

	const list = () => (
		<div className={classes.list} role="presentation" onKeyDown={toggleDrawer}>
			<List>
				{/* INICIO */}
				<ListItemButton onClick={handleMenuLink(routes.home)}>
					<ListItemIcon>
						<HomeIcon sx={{ color: '#4CAF50' }} />
					</ListItemIcon>
					<ListItemText primary="Inicio" />
				</ListItemButton>

				<Divider sx={{ my: 1 }} />

				{/* OPERACIONES DIARIAS */}
				<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
					OPERACIONES DIARIAS
				</Typography>

				{/* Cotizaciones */}
				<ListItemButton onClick={handleQuotationsClick}>
					<ListItemIcon>
						<DescriptionIcon sx={{ color: '#2196F3' }} />
					</ListItemIcon>
					<ListItemText primary="Cotizaciones" />
					{quotationsOpen ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
				<Collapse in={quotationsOpen} timeout="auto" unmountOnExit>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.quotations.new)}>
						<ListItemIcon>
							<AddBoxIcon sx={{ color: '#4CAF50' }} />
						</ListItemIcon>
						<ListItemText primary="Nueva" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.quotations.newOnlyFlights)}>
						<ListItemIcon>
							<AirplaneTicketIcon sx={{ color: '#FF9800' }} />
						</ListItemIcon>
						<ListItemText primary="Nueva solo vuelos" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.quotations.list)}>
						<ListItemIcon>
							<ListIcon sx={{ color: '#9C27B0' }} />
						</ListItemIcon>
						<ListItemText primary="Listado" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.stats.package)}>
						<ListItemIcon>
							<BeachAccessIcon sx={{ color: '#FF9800' }} />
						</ListItemIcon>
						<ListItemText primary="Paquetes" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.quotations.saleReport)}>
						<ListItemIcon>
							<BarChartIcon sx={{ color: '#FF5722' }} />
						</ListItemIcon>
						<ListItemText primary="Reporte" />
					</ListItemButton>
				</Collapse>

				{/* Órdenes de Venta */}
				<ListItemButton onClick={handleSalesOrderClick}>
					<ListItemIcon>
						<AssignmentIcon sx={{ color: '#3F51B5' }} />
					</ListItemIcon>
					<ListItemText primary="Órdenes de Venta" />
					{salesOrderOpen ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
				<Collapse in={salesOrderOpen} timeout="auto" unmountOnExit>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.salesOrder.new)}>
						<ListItemIcon>
							<AddBoxIcon sx={{ color: '#4CAF50' }} />
						</ListItemIcon>
						<ListItemText primary="Nueva" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.salesOrder.list)}>
						<ListItemIcon>
							<ListIcon sx={{ color: '#9C27B0' }} />
						</ListItemIcon>
						<ListItemText primary="Listado" />
					</ListItemButton>

					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.salesOrder.serviceList)}>
						<ListItemIcon>
							<ListIcon sx={{ color: '#414fea' }} />
						</ListItemIcon>
						<ListItemText primary="Listado de servicios" />
					</ListItemButton>

					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.salesOrder.calendar)}>
						<ListItemIcon>
							<EventAvailableIcon sx={{ color: '#2196F3' }} />
						</ListItemIcon>
						<ListItemText primary="Calendario" />
					</ListItemButton>
				</Collapse>

				<ListItemButton onClick={handleMenuLink(routes.prechargedServices)}>
					<ListItemIcon>
						<BeachAccessIcon sx={{ color: '#FF9800' }} />
					</ListItemIcon>
					<ListItemText primary="Tarifario de servicios" />
				</ListItemButton>

				{auth.user?.name && (
					<ListItemButton onClick={() => history.push(routes.salesDashboard.seller(auth.user?.name ?? ''))}>
						<ListItemIcon>
							<BarChartIcon sx={{ color: '#8E24AA' }} />
						</ListItemIcon>
						<ListItemText primary="Dashboard" />
					</ListItemButton>
				)}

				<ListItemButton onClick={handleMenuLink(routes.salesTools.documentation)}>
					<ListItemIcon>
						<TravelExploreIcon sx={{ color: '#31174B' }} />
					</ListItemIcon>
					<ListItemText primary="Herramientas de venta" />
				</ListItemButton>

				{isOperatorOrHigher(auth.user) && (
					<>
						<ListItemButton onClick={handleOperationsReportClick}>
							<ListItemIcon sx={{ color: '#9C27B0' }}>
								<ListAltIcon />
							</ListItemIcon>
							<ListItemText primary="Reportes de operaciones" />
							{operationsReportOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItemButton>
						<Collapse in={operationsReportOpen} timeout="auto" unmountOnExit>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.operations.flightAndAncillaryTickets)}>
								<ListItemIcon sx={{ color: '#9C27B0' }}>
									<ReceiptLongIcon />{' '}
								</ListItemIcon>
								<ListItemText primary="Tickets de Vuelos y Ancillaries" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.operations.flightIssuingControl)}>
								<ListItemIcon sx={{ color: '#FF9800' }}>
									<AirplaneTicketIcon />
								</ListItemIcon>
								<ListItemText primary="Control de Emisión de Vuelos" />
							</ListItemButton>
						</Collapse>
					</>
				)}

				<Divider sx={{ my: 1 }} />

				{/* GESTIÓN DE CLIENTES */}
				<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
					GESTIÓN DE CLIENTES
				</Typography>

				<ListItemButton onClick={handleMenuLink(routes.passengers.list)}>
					<ListItemIcon>
						<PersonIcon sx={{ color: '#607D8B' }} />
					</ListItemIcon>
					<ListItemText primary="Pasajeros" />
				</ListItemButton>

				<ListItemButton onClick={handleMenuLink(routes.customers.list)}>
					<ListItemIcon>
						<BusinessIcon sx={{ color: '#607D8B' }} />
					</ListItemIcon>
					<ListItemText primary="Clientes" />
				</ListItemButton>

				{isAdminOrSuperAdmin(auth.user) && (
					<ListItemButton onClick={handleMenuLink(routes.creditRules.root)}>
						<ListItemIcon>
							<HandshakeIcon sx={{ color: '#607D8B' }} />
						</ListItemIcon>
						<ListItemText primary="Condiciones de crédito" />
					</ListItemButton>
				)}

				<Divider sx={{ my: 1 }} />

				{/* PAGOS Y TRANSACCIONES */}
				<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
					PAGOS Y TRANSACCIONES
				</Typography>

				{/* Enlaces de Pago */}
				<ListItemButton onClick={handlePaymentClick}>
					<ListItemIcon>
						<AddCardIcon sx={{ color: '#4CAF50' }} />
					</ListItemIcon>
					<ListItemText primary="Enlaces de Pago" />
					{paymentOpen ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
				<Collapse in={paymentOpen} timeout="auto" unmountOnExit>
					{auth.country === CountryCodeEnum.TN_ITAU_PY ? (
						<ListItemButton sx={{ pl: 4 }} onClick={handleOrderViajeNaranja}>
							<ListItemIcon>
								<img src={bancard} style={{ height: 30 }} />
							</ListItemIcon>
							<ListItemText primary="BanCard" />
						</ListItemButton>
					) : (
						orderTypesAllowed.map((order) => {
							return (
								<ListItemButton key={`order-${order.id}`} sx={{ pl: 4 }} onClick={() => handleOrdersClick(order.id)}>
									<ListItemIcon>{order.icon()}</ListItemIcon>
									<ListItemText primary={order.name} />
								</ListItemButton>
							);
						})
					)}

					<ListItemButton sx={{ pl: 4 }} onClick={handleWireTransferCheckClick}>
						<ListItemIcon>
							<TransferIcon />
						</ListItemIcon>
						<ListItemText primary="Transferencia bancaria" />
					</ListItemButton>
					{auth.country !== CountryCodeEnum.TN_ITAU_PY && (
						<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.payment.orderCash)}>
							<ListItemIcon>
								<CashIcon />
							</ListItemIcon>
							<ListItemText primary="Pago en efectivo" />
						</ListItemButton>
					)}
				</Collapse>

				{/* Transacciones */}
				{isOperatorOrHigher(auth.user) && (
					<>
						<ListItemButton onClick={handleTransactionsListClick}>
							<ListItemIcon>
								<CreditScoreIcon sx={{ color: '#FF9800' }} />
							</ListItemIcon>
							<ListItemText primary="Transacciones" />
							{transactionsListOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItemButton>
						<Collapse in={transactionsListOpen} timeout="auto" unmountOnExit>
							{maybeOrderSimple && (
								<>
									<ListItemButton sx={{ pl: 4 }} onClick={handleCardToAirlineCollapseClick}>
										<ListItemIcon>
											<CreditScoreIcon />
										</ListItemIcon>
										<ListItemText primary="Tarjeta a Aerolínea" />
										{cardToAirlineOpen ? <ExpandLess /> : <ExpandMore />}
									</ListItemButton>
									<Collapse in={cardToAirlineOpen} timeout="auto" unmountOnExit>
										<ListItemButton
											key={`transaction-order-${maybeOrderSimple.id}`}
											sx={{ pl: 6 }}
											onClick={handleMenuLink(routes.transactions.list)}
										>
											<ListItemIcon>{maybeOrderSimple.icon()}</ListItemIcon>
											<ListItemText primary={maybeOrderSimple.name} />
										</ListItemButton>

										<ListItemButton sx={{ pl: 6 }} onClick={handleMenuLink(routes.authorizations.list)}>
											<ListItemIcon>
												<EventAvailableIcon />
											</ListItemIcon>
											<ListItemText primary="Autorizaciones" />
										</ListItemButton>
										<ListItemButton sx={{ pl: 6 }} onClick={handleMenuLink(routes.crosses.list)}>
											<ListItemIcon>
												<ImportExportIcon />
											</ListItemIcon>
											<ListItemText primary="Cruces" />
										</ListItemButton>
									</Collapse>
								</>
							)}
							{isAdminOrSuperAdmin(auth.user) && (
								<>
									{auth.country === CountryCodeEnum.TN_ITAU_PY ? (
										<>
											<ListItemButton sx={{ pl: 4 }} onClick={handleListViajeNaranjaBancardTransactionList}>
												<ListItemIcon>
													<img src={bancard} style={{ height: 30 }} />
												</ListItemIcon>
												<ListItemText primary="BanCard" />
											</ListItemButton>
											<ListItemButton sx={{ pl: 4 }} onClick={handleListViajeNaranjaPointTransactionList}>
												<ListItemIcon>
													<img src={itauPY} style={{ height: 30 }} />
												</ListItemIcon>
												<ListItemText primary="Itau" />
											</ListItemButton>
										</>
									) : (
										orderTypesAllowed.map(
											(order) =>
												order.id !== OrderTypeEnum.SIMPLE && (
													<ListItemButton
														key={`transaction-order-${order.id}`}
														sx={{ pl: 4 }}
														onClick={() => handleTransactionsClick(order.id)}
													>
														<ListItemIcon>{order.icon()}</ListItemIcon>
														<ListItemText primary={order.name} />
													</ListItemButton>
												),
										)
									)}
									{auth.country !== CountryCodeEnum.TN_ITAU_PY && (
										<>
											<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.transactions.cashTransactions)}>
												<ListItemIcon>
													<CashIcon />
												</ListItemIcon>
												<ListItemText primary="Pagos en efectivo" />
											</ListItemButton>
										</>
									)}
								</>
							)}
						</Collapse>
					</>
				)}
				<ListItemButton onClick={handleMenuLink(routes.transactions.listV2)}>
					<ListItemIcon>
						<CreditCardIcon sx={{ color: '#FFB300' }} />
					</ListItemIcon>
					<ListItemText primary="C2A" />
				</ListItemButton>
				{/* Mesa de cruces: operador o superior, como la página (`getCardDeskAccess`) */}
				{isOperatorOrHigher(auth.user) && (
					<ListItemButton onClick={handleMenuLink(routes.operations.cardDeskBoard)}>
						<ListItemIcon>
							<CompareArrowsIcon sx={{ color: '#5E35B1' }} />
						</ListItemIcon>
						<ListItemText primary="Mesa de cruces" />
					</ListItemButton>
				)}
				<ListItemButton onClick={handleMenuLink(routes.airlines.merchantAndInstallments)}>
					<ListItemIcon>
						<StorefrontIcon sx={{ color: '#7B1FA2' }} />
					</ListItemIcon>
					<ListItemText primary="Comercios y cuotas" />
				</ListItemButton>

				<Divider sx={{ my: 1 }} />

				{/* EXPLORADOR */}
				<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
					EXPLORADOR
				</Typography>

				<ListItemButton onClick={handleExplorerClick}>
					<ListItemIcon>
						<PublicIcon sx={{ color: '#2196F3' }} />
					</ListItemIcon>
					<ListItemText primary="Explorador" />
					{explorerOpen ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
				<Collapse in={explorerOpen} timeout="auto" unmountOnExit>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.packageExplorer.list)}>
						<ListItemIcon>
							<TravelExploreIcon sx={{ color: '#8BC34A' }} />
						</ListItemIcon>
						<ListItemText primary="Paquetes" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.flightExplorer.list)}>
						<ListItemIcon>
							<LocalAirportIcon sx={{ color: '#00BCD4' }} />
						</ListItemIcon>
						<ListItemText primary="Vuelos" />
					</ListItemButton>
				</Collapse>

				<Divider sx={{ my: 1 }} />

				{/* PRODUCTO */}
				<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
					PRODUCTO
				</Typography>

				{/* Catálogo (ex "Producto") — paquetes de la Support API */}
				<ListItemButton onClick={handleProductClick}>
					<ListItemIcon>
						<InventoryIcon sx={{ color: '#FF5722' }} />
					</ListItemIcon>
					<ListItemText primary="Catálogo" />
					{productOpen ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
				<Collapse in={productOpen} timeout="auto" unmountOnExit>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.product.pulse)}>
						<ListItemIcon>
							<MonitorHeartIcon sx={{ color: '#E91E63' }} />
						</ListItemIcon>
						<ListItemText primary="Pulso del catálogo" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.product.explorer)}>
						<ListItemIcon>
							<TravelExploreIcon sx={{ color: '#8BC34A' }} />
						</ListItemIcon>
						<ListItemText primary="Buscador de paquetes" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.product.destinations)}>
						<ListItemIcon>
							<PublicIcon sx={{ color: '#2196F3' }} />
						</ListItemIcon>
						<ListItemText primary="Precios por destino" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.product.priceWatch)}>
						<ListItemIcon>
							<PriceChange sx={{ color: '#4CAF50' }} />
						</ListItemIcon>
						<ListItemText primary="Movimientos de precio" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.airRoutes.root)}>
						<ListItemIcon>
							<LocalAirportIcon sx={{ color: '#0277BD' }} />
						</ListItemIcon>
						<ListItemText primary="Rutas Aéreas" />
					</ListItemButton>
				</Collapse>

				{/* Análisis de Producto — solo Admin/SuperAdmin */}
				{isAdminOrSuperAdmin(auth.user) && (
					<>
						<ListItemButton onClick={handleProductAnalyticsClick}>
							<ListItemIcon>
								<BarChartIcon sx={{ color: '#7B1FA2' }} />
							</ListItemIcon>
							<ListItemText primary="Análisis de Producto" />
							{productAnalyticsOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItemButton>
						<Collapse in={productAnalyticsOpen} timeout="auto" unmountOnExit>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.root)}>
								<ListItemIcon>
									<BarChartIcon sx={{ color: '#9C27B0' }} />
								</ListItemIcon>
								<ListItemText primary="Resumen" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.seasonality)}>
								<ListItemIcon>
									<TravelExploreIcon sx={{ color: '#2196F3' }} />
								</ListItemIcon>
								<ListItemText primary="Estacionalidad" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.destinations)}>
								<ListItemIcon>
									<PublicIcon sx={{ color: '#4CAF50' }} />
								</ListItemIcon>
								<ListItemText primary="Destinos" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.mix)}>
								<ListItemIcon>
									<InventoryIcon sx={{ color: '#FF9800' }} />
								</ListItemIcon>
								<ListItemText primary="Mix de producto" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.airlines)}>
								<ListItemIcon>
									<LocalAirportIcon sx={{ color: '#00BCD4' }} />
								</ListItemIcon>
								<ListItemText primary="Aerolíneas y rutas" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.accommodations)}>
								<ListItemIcon>
									<HotelIcon sx={{ color: '#E91E63' }} />
								</ListItemIcon>
								<ListItemText primary="Alojamientos" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.passengers)}>
								<ListItemIcon>
									<PersonIcon sx={{ color: '#607D8B' }} />
								</ListItemIcon>
								<ListItemText primary="Pasajeros" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.pricing)}>
								<ListItemIcon>
									<PriceChange sx={{ color: '#4CAF50' }} />
								</ListItemIcon>
								<ListItemText primary="Precios (ASP)" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.cancellations)}>
								<ListItemIcon>
									<ImportExportIcon sx={{ color: '#F44336' }} />
								</ListItemIcon>
								<ListItemText primary="Cancelaciones" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.productAnalytics.admin)}>
								<ListItemIcon>
									<AdminPanelSettingsIcon sx={{ color: '#E65100' }} />
								</ListItemIcon>
								<ListItemText primary="Admin Fees" />
							</ListItemButton>
						</Collapse>
					</>
				)}

				<Divider sx={{ my: 1 }} />

				{/* REPORTES Y ESTADÍSTICAS */}
				<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
					REPORTES Y ESTADÍSTICAS
				</Typography>

				<ListItemButton onClick={handleStatsClick}>
					<ListItemIcon>
						<SvgIcon sx={{ color: '#9C27B0' }}>
							<StatsIcon />
						</SvgIcon>
					</ListItemIcon>
					<ListItemText primary="Estadísticas" />
					{statsOpen ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
				<Collapse in={statsOpen} timeout="auto" unmountOnExit>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.stats.ratesList)}>
						<ListItemIcon>
							<CurrencyExchange sx={{ color: '#4CAF50' }} />
						</ListItemIcon>
						<ListItemText primary="Tasas" />
					</ListItemButton>
					{isAdminOrSuperAdmin(auth.user) && (
						<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.stats.ratesAdmin)}>
							<ListItemIcon>
								<PriceChange sx={{ color: 'success.main' }} />
							</ListItemIcon>
							<ListItemText primary="Administrar Tasas" />
						</ListItemButton>
					)}
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.stats.package)}>
						<ListItemIcon>
							<BeachAccessIcon sx={{ color: '#FF9800' }} />
						</ListItemIcon>
						<ListItemText primary="Paquetes" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.stats.automaticRoute)}>
						<ListItemIcon>
							<AirplaneTicketIcon sx={{ color: '#2196F3' }} />
						</ListItemIcon>
						<ListItemText primary="Vuelos" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.dataStudio)}>
						<ListItemIcon>
							<BarChartIcon sx={{ color: '#9C27B0' }} />
						</ListItemIcon>
						<ListItemText primary="Looker" />
					</ListItemButton>
				</Collapse>

				<Divider sx={{ my: 1 }} />

				{/* CONFIGURACIÓN */}
				<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
					CONFIGURACIÓN
				</Typography>

				<ListItemButton onClick={handleQuotationOptionsClick}>
					<ListItemIcon>
						<SettingsIcon sx={{ color: '#795548' }} />
					</ListItemIcon>
					<ListItemText primary="Cotizaciones" />
					{quotationOptionsOpen ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
				<Collapse in={quotationOptionsOpen} timeout="auto" unmountOnExit>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.quotations.description)}>
						<ListItemIcon>
							<ContentPaste sx={{ color: '#607D8B' }} />
						</ListItemIcon>
						<ListItemText primary="Descripciones por defecto" />
					</ListItemButton>
					<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.quotations.defaultNotIncludes)}>
						<ListItemIcon>
							<PlaylistRemove sx={{ color: '#F44336' }} />
						</ListItemIcon>
						<ListItemText primary="No incluye por defecto" />
					</ListItemButton>
				</Collapse>

				{isAdminOrSuperAdmin(auth.user) && (
					<>
						<ListItemButton onClick={handleRulesClick}>
							<ListItemIcon>
								<ListIcon sx={{ color: '#673AB7' }} />
							</ListItemIcon>
							<ListItemText primary="Reglas de emisión" />
							{rulesOpen ? <ExpandLess /> : <ExpandMore />}
						</ListItemButton>
						<Collapse in={rulesOpen} timeout="auto" unmountOnExit>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.flightIssueRule.list)}>
								<ListItemIcon>
									<AirplaneTicketIcon sx={{ color: '#FF9800' }} />
								</ListItemIcon>
								<ListItemText primary="Reglas de vuelos" />
							</ListItemButton>
							<ListItemButton sx={{ pl: 4 }} onClick={handleMenuLink(routes.costIssuingRules.list)}>
								<ListItemIcon>
									<CurrencyExchange sx={{ color: '#4CAF50' }} />
								</ListItemIcon>
								<ListItemText primary="Costos de emisión" />
							</ListItemButton>
						</Collapse>
					</>
				)}

				<ListItemButton onClick={handleMenuLink(routes.tools.emailSignature)}>
					<ListItemIcon>
						<ContentPaste sx={{ color: '#31174B' }} />
					</ListItemIcon>
					<ListItemText primary="Firma Mail" />
				</ListItemButton>

				{/* Mapeo de flow CRM — solo SUPERADMIN */}
				{isSuperAdmin(auth.user) && (
					<ListItemButton onClick={() => history.push(routes.salesDashboard.admin)}>
						<ListItemIcon>
							<AdminPanelSettingsIcon sx={{ color: '#E65100' }} />
						</ListItemIcon>
						<ListItemText primary="Mapeo de flow CRM" />
					</ListItemButton>
				)}

				{/* ADMINISTRACIÓN */}
				{isAdminOrSuperAdmin(auth.user) && (
					<>
						<Divider sx={{ my: 1 }} />
						<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
							ADMINISTRACIÓN
						</Typography>

						<ListItemButton onClick={handleMenuLink(routes.providers.list)}>
							<ListItemIcon>
								<ListAltIcon sx={{ color: '#FF5722' }} />
							</ListItemIcon>
							<ListItemText primary="Proveedores" />
						</ListItemButton>

						<ListItemButton onClick={handleMenuLink(routes.providers.paymentCalendar)}>
							<ListItemIcon>
								<RequestQuoteIcon sx={{ color: '#414fea' }} />
							</ListItemIcon>
							<ListItemText primary="Calendario de pago a proveedores" />
						</ListItemButton>

						<ListItemButton onClick={handleMenuLink(routes.branchOffices.list)}>
							<ListItemIcon>
								<HomeWork sx={{ color: '#FF5722' }} />
							</ListItemIcon>
							<ListItemText primary="Sucursales y pagos" />
						</ListItemButton>

						<ListItemButton onClick={handleMenuLink(routes.sellers.teamsAndGoals)}>
							<ListItemIcon>
								<GroupsIcon sx={{ color: '#3F51B5' }} />
							</ListItemIcon>
							<ListItemText primary="Vendedores: equipo y objetivo" />
						</ListItemButton>

						{/* <ListItemButton onClick={handleMenuLink(routes.user.list)}>
							<ListItemIcon>
								<GroupsIcon sx={{ color: '#3F51B5' }} />
							</ListItemIcon>
							<ListItemText primary="Usuarios" />
						</ListItemButton> */}

						{/* <ListItemButton onClick={handleMenuLink(routes.agency.list)}>
							<ListItemIcon>
								<GroupsIcon sx={{ color: '#9C27B0' }} />
							</ListItemIcon>
							<ListItemText primary="Agencias" />
						</ListItemButton> */}

						{/* <ListItemButton sx={{ pl: 2 }} onClick={handleMenuLink(routes.user.new)}>
							<ListItemIcon>
								<AddBoxIcon sx={{ color: '#4CAF50' }} />
							</ListItemIcon>
							<ListItemText primary="Nuevo Usuario" />
						</ListItemButton> */}

						{/* <ListItemButton sx={{ pl: 2 }} onClick={handleMenuLink(routes.agency.new)}>
							<ListItemIcon>
								<AddBoxIcon sx={{ color: '#4CAF50' }} />
							</ListItemIcon>
							<ListItemText primary="Nueva Agencia" />
						</ListItemButton> */}

						{/* <ListItemButton sx={{ pl: 2 }} onClick={handleMenuLink(routes.agency.update)}>
							<ListItemIcon>
								<SettingsIcon sx={{ color: '#FF9800' }} />
							</ListItemIcon>
							<ListItemText primary="Actualizar Agencia" />
						</ListItemButton> */}

						<ListItemButton onClick={handleMenuLink(routes.activityLogList)}>
							<ListItemIcon>
								<ListAltIcon sx={{ color: '#795548' }} />
							</ListItemIcon>
							<ListItemText primary="Log de actividades" />
						</ListItemButton>

						{isSuperAdmin(auth.user) && (
							<ListItemButton onClick={handleMenuLink(routes.branchCash.overview)}>
								<ListItemIcon>
									<AccountBalanceIcon sx={{ color: '#1565C0' }} />
								</ListItemIcon>
								<ListItemText primary="Cajas" />
							</ListItemButton>
						)}

						{isSuperAdmin(auth.user) && (
							<ListItemButton onClick={handleMenuLink(routes.mcpConnector.users)}>
								<ListItemIcon>
									<HubIcon sx={{ color: '#6A1B9A' }} />
								</ListItemIcon>
								<ListItemText primary="Conector de datos (Claude)" />
							</ListItemButton>
						)}
					</>
				)}

				{/* TARJETAS CORPORATIVAS */}
				{isAdminOrSuperAdmin(auth.user) && (
					<>
						<Divider sx={{ my: 1 }} />
						<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
							TARJETAS CORPORATIVAS
						</Typography>
						<ListItemButton onClick={handleMenuLink(routes.corporateCards.root)}>
							<ListItemIcon>
								<CreditCardIcon sx={{ color: '#1565C0' }} />
							</ListItemIcon>
							<ListItemText primary="Tarjetas corporativas" />
						</ListItemButton>
					</>
				)}

				{/* PAGOS A PROVEEDORES */}
				{isAdminOrSuperAdmin(auth.user) && (
					<>
						<Divider sx={{ my: 1 }} />
						<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
							PAGOS A PROVEEDORES
						</Typography>

						<ListItemButton onClick={handleMenuLink(routes.providerPayments.list)}>
							<ListItemIcon>
								<PaymentsIcon sx={{ color: '#2E7D32' }} />
							</ListItemIcon>
							<ListItemText primary="Listado de órdenes" />
						</ListItemButton>

						<ListItemButton onClick={handleMenuLink(routes.providerPayments.bulk)}>
							<ListItemIcon>
								<UploadFileIcon sx={{ color: '#1565C0' }} />
							</ListItemIcon>
							<ListItemText primary="Pagos masivos" />
						</ListItemButton>

						<ListItemButton onClick={handleMenuLink(routes.providerPayments.payments)}>
							<ListItemIcon>
								<ReceiptLongIcon sx={{ color: '#6A1B9A' }} />
							</ListItemIcon>
							<ListItemText primary="Listado de pagos" />
						</ListItemButton>
					</>
				)}

				<Divider sx={{ my: 1 }} />

				{/* COBROS A CLIENTES */}
				{isOperatorOrHigher(auth.user) && (
					<>
						<Divider sx={{ my: 1 }} />
						<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
							COBROS A CLIENTES
						</Typography>

						<ListItemButton onClick={handleMenuLink(routes.clientPayments.list)}>
							<ListItemIcon>
								<PaymentsIcon sx={{ color: '#00897B' }} />
							</ListItemIcon>
							<ListItemText primary="Listado de recibos" />
						</ListItemButton>

						<ListItemButton onClick={handleMenuLink(routes.invoices.list)}>
							<ListItemIcon>
								<RequestQuoteIcon sx={{ color: '#00695C' }} />
							</ListItemIcon>
							<ListItemText primary="Facturas" />
						</ListItemButton>

						{isAdminOrSuperAdmin(auth.user) && (
							<ListItemButton onClick={handleMenuLink(routes.receivables.cartera)}>
								<ListItemIcon>
									<MonitorHeartIcon sx={{ color: '#004D40' }} />
								</ListItemIcon>
								<ListItemText primary="Salud de cartera" />
							</ListItemButton>
						)}
					</>
				)}

				<Divider sx={{ my: 1 }} />

				{/* INFORMACIÓN DE CUPOS */}
				<ListItemButton onClick={handleMenuLink(routes.quotaData)}>
					<ListItemIcon>
						<AnnouncementIcon sx={{ color: '#FF9800' }} />
					</ListItemIcon>
					<ListItemText primary="Información de Cupos" />
				</ListItemButton>

				{/* DEVOLUCIONES */}
				<ListItemButton onClick={handleMenuLink(routes.refund)}>
					<ListItemIcon>
						<ImportExportIcon sx={{ color: '#F44336' }} />
					</ListItemIcon>
					<ListItemText primary="Devoluciones" />
				</ListItemButton>

				{/* TEMPORAL - HOTELES - COMENTADO */}
				{/* <Divider sx={{ my: 1 }} />

				<Typography variant="overline" sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: '0.7rem' }}>
					TEMPORAL - HOTELES
				</Typography>
				
				<ListItemButton onClick={handleMenuLink(routes.hotels.search)}>
					<ListItemIcon>
						<HotelIcon sx={{ color: '#E91E63' }} />
					</ListItemIcon>
					<ListItemText primary="Búsqueda de Hoteles" />
				</ListItemButton>

				<ListItemButton onClick={handleMenuLink(routes.hotels.fareCard)}>
					<ListItemIcon>
						<HotelIcon sx={{ color: '#FF9800' }} />
					</ListItemIcon>
					<ListItemText primary="Tarifa de Hoteles" />
				</ListItemButton>

				<ListItemButton onClick={handleMenuLink(routes.hotels.searchReservations)}>
					<ListItemIcon>
						<HotelIcon sx={{ color: '#2196F3' }} />
					</ListItemIcon>
					<ListItemText primary="Búsqueda de Reservas" />
				</ListItemButton> */}
			</List>
			<Divider />
		</div>
	);

	return (
		<div className="App">
			<AppBar position="static">
				<Toolbar className={classes.toolbar}>
					{/* Sección Izquierda */}
					<div className={classes.leftSection}>
						<IconButton
							edge="start"
							className={classes.menuButton}
							color="inherit"
							aria-label="menu"
							onClick={toggleDrawer}
							size="large"
						>
							<MenuIcon />
						</IconButton>
						<RouterLink to="/home" style={{ textDecoration: 'none', color: 'white' }}>
							<Typography variant="h6" className={classes.title} sx={{ display: { xs: 'none', sm: 'block' } }}>
								Power
							</Typography>
						</RouterLink>

						{/* Selector de País Simplificado */}
						{currentCountryConfig && (
							<Chip
								className={classes.countryChip}
								avatar={
									<Avatar sx={{ bgcolor: 'transparent' }}>
										<img src={currentCountryConfig.agencyIcon} alt="country" className={classes.flagIcon} />
									</Avatar>
								}
								label={currentCountryConfig.countryName}
								onClick={handleCountryMenuOpen}
								deleteIcon={<ExpandMoreIcon />}
								onDelete={handleCountryMenuOpen}
								variant="filled"
								size={isSmallScreen ? 'small' : 'medium'}
								sx={{ ml: { xs: 0.5, sm: 2 } }}
							/>
						)}
					</div>

					{/* Sección Central - Logo (Solo en desktop) */}
					<div className={classes.centerSection}>
						<img className={classes.logo} src={MevueloLogo} alt="Mevuelo-logo" />
					</div>

					{/* Sección Derecha */}
					<div className={classes.rightSection}>
						{/* Logo móvil */}
						<Box sx={{ display: { xs: 'block', md: 'none' } }}>
							<img className={classes.logo} src={MevueloLogo} alt="Mevuelo-logo" />
						</Box>

						{/* Menú de Usuario */}
						<IconButton
							className={classes.userMenuButton}
							onClick={handleUserMenuOpen}
							size="large"
							aria-label="user menu"
						>
							<AccountCircleIcon fontSize="large" />
						</IconButton>
					</div>
				</Toolbar>
			</AppBar>

			{/* Menú de Selección de País */}
			<Menu
				anchorEl={countryMenuAnchor}
				open={Boolean(countryMenuAnchor)}
				onClose={handleCountryMenuClose}
				PaperProps={{
					sx: {
						mt: 1,
						minWidth: 200,
						'& .MuiMenuItem-root': {
							px: 2,
							py: 1,
						},
					},
				}}
			>
				{countriesConfigToRender.map((countryConfig) => (
					<MenuItem
						key={countryConfig.id}
						onClick={() => handleCountryChange(countryConfig.id)}
						selected={auth.country === countryConfig.id}
					>
						<ListItemAvatar>
							<Avatar sx={{ width: 32, height: 24, bgcolor: 'transparent' }}>
								<img src={countryConfig.agencyIcon} alt={countryConfig.countryName} className={classes.flagIcon} />
							</Avatar>
						</ListItemAvatar>
						<ListItemText primary={countryConfig.countryName} />
					</MenuItem>
				))}
			</Menu>

			{/* Menú de Usuario */}
			<Menu
				anchorEl={userMenuAnchor}
				open={Boolean(userMenuAnchor)}
				onClose={handleUserMenuClose}
				PaperProps={{
					sx: {
						mt: 1,
						minWidth: 180,
						'& .MuiMenuItem-root': {
							px: 2,
							py: 1,
						},
					},
				}}
			>
				<MenuItem disabled>
					<ListItemIcon>
						<AccountCircleIcon />
					</ListItemIcon>
					<ListItemText
						primary={auth.user?.email || 'Usuario'}
						primaryTypographyProps={{
							variant: 'body2',
							sx: { fontWeight: 'bold' },
						}}
					/>
				</MenuItem>
				<Divider />
				<MenuItem
					onClick={() => {
						handleUserMenuClose();
						handleLogout();
					}}
				>
					<ListItemIcon>
						<LogoutIcon />
					</ListItemIcon>
					<ListItemText primary="Cerrar Sesión" />
				</MenuItem>
			</Menu>
			{props.children}
			<Drawer
				anchor="left"
				open={drawerOpen}
				onClose={toggleDrawer}
				sx={{
					'& .MuiDrawer-paper': {
						'&::-webkit-scrollbar': {
							width: '8px',
						},
						'&::-webkit-scrollbar-track': {
							backgroundColor: '#f1f1f1',
							borderRadius: '4px',
						},
						'&::-webkit-scrollbar-thumb': {
							backgroundColor: '#c1c1c1',
							borderRadius: '4px',
							'&:hover': {
								backgroundColor: '#a8a8a8',
							},
						},
						scrollbarWidth: 'thin', // Para Firefox
						scrollbarColor: '#c1c1c1 #f1f1f1', // Para Firefox
					},
				}}
			>
				{list()}
			</Drawer>
		</div>
	);
};
